import { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import iconlogo from '../assets/iconLogo.png'
import { screensize } from "./Screensize";
import { earlysubmit } from "../Logic/index01";
import { CircularProgress } from "react-loader-spinner";
/**
 * UI.live early-access landing page
 * Plain React + inline <style>. No dependencies beyond React.
 */

const chips = [
  { label: "Vehicles", color: "#22a559", bg: "#e3f6ea", icon: "vehicle", style: { top: "3.5%", left: screensize() ? "30%" : "45%" } },
  { label: "little ones", color: "#2d6cf0", bg: "#e1ecff", icon: "kids", style: { top: screensize() ? "20%" : "45%", left: screensize() ? "10%" : "14.5%" } },
  { label: "Assets", color: "#ef5a2f", bg: "#ffe6dd", icon: "assets", style: { top:screensize() ? "14%": "39%", right: screensize() ? "5%" : "15%" } },
  { label: "Elderly", color: "#7c4dff", bg: "#ece5ff", icon: "elderly", style: { bottom: "20%", left: screensize() ? "10%" : "35%" } },
  { label: "And much more", plain: true, style: { bottom: "18%", right: screensize() ? "10%" : "25%" } },
];

const dots = [
  { top: "21%", left: "3.5%", s: 5 },
  { top: "74%", left: "4.5%", s: 6 },
  { top: "20%", right: "9%", s: 7 },
  { top: "52%", right: "20%", s: 14 },
  { top: "52%", left: "19%", s: 12 },
  { bottom: "14%", right: "3%", s: 5 },
];

function Icon({ name, color }) {
const p = {
  width: 16,
  height: 16,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: color,
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

if (name === "elderly") {
  return (
    <svg {...p}>
      <circle cx="12" cy="5" r="2" />
      <path d="M11 7a2 2 0 0 0-2 2v4l1.5 3h1.5l1-4h1l1 4h1.5" />
      <path d="M7 21h2l1-7" />
      <path d="M16 8l1 3v10" />
    </svg>
  );
}

if (name === "kids") {
  return (
    <svg {...p}>
      <circle cx="12" cy="13" r="5" />
      <circle cx="12" cy="6" r="3" />
      <circle cx="8" cy="4" r="1.5" />
      <circle cx="16" cy="4" r="1.5" />
      <circle cx="6" cy="12" r="1" />
      <circle cx="18" cy="12" r="1" />
    </svg>
  );
}

if (name === "vehicle") {
  return (
    <svg {...p}>
      <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" />
      <circle cx="7" cy="17" r="2" />
      <path d="M9 17h6" />
      <circle cx="17" cy="17" r="2" />
    </svg>
  );
}


return (
  <svg {...p}>
    <circle cx="12" cy="12" r="1" />
    <circle cx="19" cy="12" r="1" />
    <circle cx="5" cy="12" r="1" />
  </svg>
);

}

function Logo() {
  return (
    <div width="60" heigh="70">
      <img src={iconlogo} />
    </div>
  );
}

const  UILiveLanding = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(0);
  const [load, setLoad] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); 
    if (!/^\S+@\S+\.\S+$/.test(email)) return;
      if(!load){
        setLoad(true);
        let res = await earlysubmit(email);
          if(res === "ok"){
            setLoad(false);
            setDone(1);
          }else{
            setLoad(false);
            setDone(2);
          }
       }
  };

  return (<>
            <Header/>
            <div className="uil-bg; mt-16">
             <style>{css}</style>
              <main className="uil-card">
                {/* orbit rings */}
                <div className="uil-ring uil-ring-lg" />
                <div className="uil-ring uil-ring-md" />

           
                {dots.map((d, i) => {
                  const { s, ...pos } = d;
                  return <span key={i} className="uil-dot" style={{ ...pos, width: s, height: s }} />;
                })}

                
                {chips.map((c) => (
                 <div key={c.label} className="uil-chip" style={c.style}>
                    {!c.plain && (
                    <span className="uil-chip-icon" style={{ background: c.bg }}>
                        <Icon name={c.icon} color={c.color} />
                    </span>
                    )}
                    <span>{c.label}</span>
                </div>
                ))}

                {/* center content */}
                <section className="uil-center">
                   <h1 className="uil-title">
                    <span className="uil-line">Track.</span>
                    <span className="uil-line uil-row">
                    <span>Connect.</span>
                    <span className="uil-logo"><Logo /></span>
                    <span>Protect.</span>
                    </span>
                   </h1>

                <p className="uil-copy">
                    We’ve been working hard behind the scenes, and we are excited to invite you to the Early Access program for 
                    <strong> Beeppee</strong>—our 
                    new real-time location tracking<strong>+</strong> app built to keep you connected to the people and things that matter moste.
                </p>

                {done == 1 ? (
                    <div className="uil-form uil-done" role="status">You're on the list. We'll email you soon.</div>
                 ) : done == 2 ? (
                    <div className="uil-form uil-done;  text-red-600" role="status">Sorry can't add you to the list with this email.</div>
                ) : (
                    <form className="uil-form" onSubmit={submit}>
                      <div className="uil-field">
                          <label htmlFor="uil-email">Enter email</label>
                          <input
                          id="uil-email"
                          type="email"
                          required
                          placeholder="you@example.com"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          />
                      </div>
                      <button type="submit" disabled={load} className="flex justify-center items-center" >
                        {load ? <CircularProgress color="#fff" height={15} width={15} /> : "Request early access"}
                      </button>
                    </form>
                )}
                </section>

                {/* socials + footer */}
                <footer className="uil-foot">
                 <div className="uil-socials">
                    <a href="https://x.com/BeeppeeApp" aria-label="X">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.2 2H21l-6.5 7.4L22 22h-6l-4.7-6.1L5.9 22H3.1l7-8L2 2h6.1l4.2 5.6zm-1 18h1.6L7 3.9H5.3z" /></svg>
                    </a>
                    <a href="https://www.instagram.com/beeppeeapp" aria-label="Instagram">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="1" fill="currentColor" /></svg>
                    </a>
                    <a href="https://www.facebook.com/BeeppeeApp" aria-label="facebook">
                  <svg xmlns="http://w3.org" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c4.56-.93 8-4.96 8-9.75z"/>
                  </svg>  </a>
                </div>
                <div className="uil-built">
                    Beeppee
                </div>
                </footer>
              </main>
            </div>
        <Footer/>
      </>
  );
}



export default UILiveLanding;




const css = `
.uil-bg{
  min-height:auto;
  padding:6px;
  box-sizing:border-box;
  font-family:"Plus Jakarta Sans","Inter",system-ui,-apple-system,"Segoe UI",sans-serif;
  color:#111;
}
.uil-card{
  position:relative;
  min-height:calc(100vh - 12px);
  overflow:hidden;
  background:#f1eff0;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  padding:48px 20px 90px;
  box-sizing:border-box;
}
.uil-ring{
position:absolute;
left:50%;
top:50%;
border-radius:50%;
border:1.5px solid #dcd9dc;
transform:translate(-50%,-50%);
pointer-events:none
}
.uil-ring-lg{
width:min(110vh,700px);
height:min(110vh,700px)
}
.uil-ring-md{
width:min(58vh,680px);
height:min(58vh,680px);
background:rgba(255,255,255,.18)
}

.uil-dot{position:absolute;border-radius:50%;
  background:radial-gradient(circle at 35% 30%,#fff,#c9c6ca);pointer-events:none}

.uil-chip{
  position:absolute;
  display:flex;
  align-items:center;
  gap:10px;
  padding:7px 16px 7px 8px;
  border-radius:14px;
  background:#f7f6f7;
  font-size:11.5px;
  font-weight:600;
  color:#2a2a2e;
  box-shadow:0 2px 6px rgba(0,0,0,.08),0 0 0 1px rgba(0,0,0,.04);
  animation:uil-float 6s ease-in-out infinite;
}
.uil-chip:nth-of-type(even){
animation-delay:-3s
}
.uil-chip-icon{
width:26px;
height:26px;
border-radius:8px;
display:grid;
place-items:center
}
@keyframes uil-float{
0%,100%
{
transform:translateY(0)
}
50%{transform:translateY(-5px)
}
}

.uil-center{
position:relative;
z-index:2;
max-width:340px;
text-align:center;
display:flex;
flex-direction:column;
align-items:center
}

.uil-title{
margin:0 0 14px;
font-weight:700;
letter-spacing:-.03em;
line-height:1.02;
font-size:30px
}


.uil-line{
display:block
}
.uil-row{
display:flex;
align-items:center;
justify-content:center;
gap:10px
}

.uil-logo{
width:58px;
height:58px;
border-radius:50%;
background:#fff;
display:grid;
place-items:center;
box-shadow:0 2px 8px rgba(0,0,0,.1)
}

.uil-logo svg{
width:42px;
height:42px
}

.uil-copy{margin:0 0 26px;
font-size:12.5px;
line-height:1.55;
color:#26262b
}
.uil-copy strong{
font-weight:800
}

.uil-form{
  display:flex;align-items:center;gap:8px;width:max-content;max-width:92vw;
  padding:9px;border-radius:999px;background:#fbfafb;
  box-shadow:0 1px 3px rgba(0,0,0,.06);
}
.uil-done{padding:20px 28px;font-size:13px;font-weight:600}
.uil-field{position:relative}
.uil-field label{position:absolute;top:-6px;left:16px;padding:0 4px;background:#fbfafb;
  font-size:8.5px;color:#444;z-index:1}
.uil-field input{
  width:182px;height:30px;padding:0 16px;border-radius:999px;box-sizing:content-box;
  border:1px solid #dcd9dc;background:#f3f1f3;font:inherit;font-size:10.5px;color:#222;outline:none;
}
.uil-field input:focus-visible{border-color:#7c4dff;box-shadow:0 0 0 3px rgba(124,77,255,.2)}
.uil-form button{
  height:32px;padding:0 18px;
  border:0;border-radius:999px;cursor:pointer;
  background:#1658EA;
  color:#fff;
  font:inherit;
  font-size:10.5px;
  font-weight:700;
}
.uil-form button:hover{background:#26262b}
.uil-form button:focus-visible{outline:2px solid #7c4dff;outline-offset:2px}

.uil-foot{
position:absolute;
z-index:2;
bottom:68px;
left:0;
right:0;
display:flex;
flex-direction:column;
align-items:center;
gap:14px
}
.uil-socials{
display:flex;
gap:10px
}
.uil-socials a{width:30px;height:30px;border-radius:50%;background:#f8f7f8;color:#222;
  display:grid;place-items:center;box-shadow:0 1px 4px rgba(0,0,0,.1)}
.uil-socials a:focus-visible{outline:2px solid #7c4dff;outline-offset:2px}
.uil-built{display:flex;align-items:center;gap:5px;font-size:8.5px;font-weight:600;color:#222}

@media (max-width:760px){


.uil-form{
flex-direction:column;
border-radius:24px;
width:auto;
padding:14px;
}

.uil-field input{
  width:200px
  }

.uil-form button{
 width:100%
}
}

@media (prefers-reduced-motion:reduce){
.uil-chip{
animation:none
}
}
`;